module.exports = __webpack_public_path__ + "img/spartan-tenant-improvements-02-med.047ee227.jpg";